import type { NomineeFormData } from './nomineeInfo.types';

export const NOMINEE_RELATION_VALUE_OTHERS = 'OTHERS';

export const NOMINEE_RELATION_OPTIONS = [
  { value: 'WIFE', label: 'Wife' },
  { value: 'HUSBAND', label: 'Husband' },
		{ value: 'MOTHER', label: 'Mother' },
  { value: 'FATHER', label: 'Father' },
  { value: 'SON', label: 'Son' },
  { value: 'DAUGHTER', label: 'Daughter' },
		{ value: 'SISTER', label: 'Sister' },
  { value: 'BROTHER', label: 'Brother' },
  { value: NOMINEE_RELATION_VALUE_OTHERS, label: 'Others' },
];

export const GUARDIAN_RELATION_OPTIONS = [
  { value: 'FATHER', label: 'Father' },
  { value: 'MOTHER', label: 'Mother' },
  { value: 'BROTHER', label: 'Brother' },
  { value: 'SISTER', label: 'Sister' },
  { value: 'GRAND_FATHER', label: 'Grand Father' },
  { value: 'GRAND_MOTHER', label: 'Grand Mother' },
  { value: 'OTHERS', label: 'Others' },
];

export const IDENTITY_PROOF_OPTIONS = [
  { value: 'AADHAAR', label: 'Aadhaar Number' },
  { value: 'PAN', label: 'PAN Number' },
  { value: 'DL', label: 'Driving Licence Number' },
];

export const STATE_CODES = [
	{
		label: 'Andaman & Nicobar Islands',
		value: 'AN',
	},
	{
		label: 'Andhra Pradesh',
		value: 'AP',
	},
	{
		label: 'Arunachal Pradesh',
		value: 'AR',
	},
	{
		label: 'Assam',
		value: 'AS',
	},
	{
		label: 'Bihar',
		value: 'BH',
	},
	{
		label: 'Chandigarh',
		value: 'CH',
	},
	{
		label: 'Chattisgarh',
		value: 'CG',
	},
	{
		label: 'Dadra & Nagar Haveli',
		value: 'DN',
	},
	{
		label: 'Daman & Diu',
		value: 'DD',
	},
	{
		label: 'Delhi',
		value: 'ND',
	},
	{
		label: 'Goa',
		value: 'GO',
	},
	{
		label: 'Gujarat',
		value: 'GU',
	},
	{
		label: 'Haryana',
		value: 'HA',
	},
	{
		label: 'Himachal Pradesh',
		value: 'HP',
	},
	{
		label: 'Jammu and Kashmir',
		value: 'JM',
	},
	{
		label: 'Jharkhand',
		value: 'JK',
	},
	{
		label: 'Karnataka',
		value: 'KA',
	},
	{
		label: 'Kerala',
		value: 'KE',
	},
	{
		label: 'Lakshadweep',
		value: 'LD',
	},
	{
		label: 'Madhya Pradesh',
		value: 'MP',
	},
	{
		label: 'Maharashtra',
		value: 'MA',
	},
	{
		label: 'Pondicherry',
		value: 'PO',
	},
	{
		label: 'Manipur',
		value: 'MN',
	},
	{
		label: 'Mizoram',
		value: 'MI',
	},
	{
		label: 'Nagaland',
		value: 'NA',
	},
	{
		label: 'Tripura',
		value: 'TR',
	},
	{
		label: 'Meghalaya',
		value: 'ME',
	},
	{
		label: 'Odisha',
		value: 'OR',
	},
	{
		label: 'Punjab',
		value: 'PU',
	},
	{
		label: 'Rajasthan',
		value: 'RA',
	},
	{
		label: 'Tamil Nadu',
		value: 'TN',
	},
	{
		label: 'Uttar Pradesh',
		value: 'UP',
	},
	{
		label: 'Uttarakhand',
		value: 'UC',
	},
	{
		label: 'West Bengal',
		value: 'WB',
	},
	{
		label: 'Sikkim',
		value: 'SI',
	},
	{
		label: 'Orissa',
		value: 'OR',
	},
	{
		label: 'Telangana',
		value: 'TG',
	},
];

export const INITIAL_NOMINEE_FORM: NomineeFormData = {
  nomineeId: null,
  name: '',
  relation: '',
  relationshipDescription: '',
  emailId: '',
  mobileNumber: '',
  identityProofType: '',
  identityProofNumber: '',
  isAddressSame: true,
  isMinor: false,
  address: {
    address: '',
    pincode: '',
    city: '',
    state: '',
    state_code: '',
    country: 'India',
    is_new_pincode: false,
  },
  guardianName: '',
  guardianRelation: '',
  percentageShare: 100,
  isPrimary: true,
};

export const NOMINEE_FORM_ERRORS = {
  INVALID_NAME: 'Please enter a valid nominee name (alphabets only)',
  SHORT_NAME: 'Name should contain at least 2 characters',
  SELECT_RELATION: 'Please select relation to the nominee',
  SPECIFY_RELATION_OTHER: 'Please enter relation to the nominee',
  RELATION_OTHER_TOO_LONG: 'Relation must be at most 100 characters',
  INVALID_EMAIL: 'Please enter a valid email address',
  EMPTY_EMAIL: 'Please enter an email address',
  INVALID_MOBILE: 'Please enter a valid 10-digit mobile number',
  EMPTY_MOBILE: 'Please enter a mobile number',
  SELECT_PROOF_TYPE: 'Please select identity proof type',
  INVALID_PROOF_NUMBER: 'Please enter a valid proof number',
  INVALID_ADDRESS: 'Please enter a valid address',
  INVALID_PINCODE: 'Please enter a valid 6-digit pincode',
  INVALID_CITY: 'Please enter a valid city',
  INVALID_STATE: 'Please enter a valid state',
  INVALID_DOB: 'Please enter a valid date of birth (DD/MM/YYYY)',
  INVALID_GUARDIAN_NAME: 'Please enter a valid guardian name',
  SHORT_GUARDIAN_NAME: 'Guardian name should contain at least 2 characters',
  SELECT_GUARDIAN_RELATION: 'Please select guardian\'s relation to nominee',
  SHARE_SUM_ERROR: 'Total percentage share must equal 100%',
  SHARE_ZERO_ERROR: 'Percentage share cannot be 0',
  SHARE_DECIMAL_ERROR: 'Percentage share must be a whole number',
};

export const MAX_NOMINEES = 3;

export const NOMINEE_SCREENS = {
  FORM: 'form',
  REVIEW: 'review',
} as const;
